function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.516 13.934a1.29 1.29 0 0 0 1.268-1.268V8.627a1.274 1.274 0 1 0-2.548 0v4.039a1.292 1.292 0 0 0 1.28 1.268zm6.972 2.684a1.26 1.26 0 0 0 1.79 0l2.858-2.871a1.274 1.274 0 1 0-1.8-1.8l-2.846 2.871a1.275 1.275 0 0 0-.002 1.801zm-13.957 0a1.3 1.3 0 0 0 0-1.8l-2.846-2.872a1.274 1.274 0 1 0-1.8 1.8l2.846 2.871a1.275 1.275 0 0 0 1.8.002z",
  transform: "rotate(45 15.023 5.26)"
});

function SvgSunshine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.799,
    height: 23.799,
    viewBox: "0 0 23.799 23.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunshine);
export default __webpack_public_path__ + "static/media/sunshine.00f63cfb.svg";
export { ForwardRef as ReactComponent };